// extracted by mini-css-extract-plugin
export var typingIndicator = "_p8-0";